"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var PlanItems_1 = __importDefault(require("./PlanItems"));
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var PlanExplorerFrequencyDropdown_1 = require("./PlanExplorerFrequencyDropdown");
var eligibleForEntMonthly_1 = require("../eligibleForEntMonthly");
var PlanExplorer = (function () {
    function PlanExplorer(di, $q, createUi, $log, account, onComplete, overlayStack, isSubscribed, trial, planService, businessTrial, Tooltip, make, cancelSubscription, $timeout, telemetry, invoke, hint, $state, seatsService, speechBubble, AsyncButton, usingFeature) {
        var _this = this;
        this.di = di;
        this.$q = $q;
        this.$log = $log;
        this.onComplete = onComplete;
        this.overlayStack = overlayStack;
        this.isSubscribed = isSubscribed;
        this.trial = trial;
        this.planService = planService;
        this.businessTrial = businessTrial;
        this.cancelSubscription = cancelSubscription;
        this.$timeout = $timeout;
        this.hint = hint;
        this.seatsService = seatsService;
        this.speechBubble = speechBubble;
        this.AsyncButton = AsyncButton;
        this.usingFeature = usingFeature;
        this.getPlanList = function (isMonthly, oldList) {
            var planList = lodash_1.default.map(_this.plans, function (plan) {
                var price;
                if (isMonthly) {
                    price = plan.monthlyPrice * plan.minSeat;
                }
                else {
                    price = plan.annualPrice * plan.minSeat;
                }
                return {
                    displayName: plan.displayName,
                    price: price,
                    seats: plan.seats,
                    minSeat: plan.minSeat,
                    explainer: plan.explainer,
                };
            });
            planList = lodash_1.default.filter(planList, function (plan) { return !["Starter", "Pro"].includes(plan.displayName); });
            if (oldList != null) {
                for (var idx = 0; idx < oldList.length; idx++) {
                    var plan = oldList[idx];
                    plan.displayName = planList[idx].displayName;
                    plan.price = planList[idx].price;
                    plan.seats = planList[idx].seats;
                }
                return oldList;
            }
            return planList;
        };
        this.getFeatureList = function (currentPlan, oldList) {
            var category, features, icon, status, tooltip;
            var featureList = [];
            for (category in _this.featureCategories) {
                features = _this.featureCategories[category];
                var categoryFeatureList = [];
                for (var featureName in features) {
                    var featureDetails = features[featureName];
                    icon = currentPlan.alternativeIcons[featureName] || featureDetails.icon;
                    tooltip = null;
                    if (lodash_1.default.includes(currentPlan.features[category], featureName)) {
                        status = "available";
                    }
                    else {
                        status = "unavailable";
                    }
                    categoryFeatureList.push({
                        name: featureName,
                        icon: icon,
                        tooltip: tooltip,
                        status: status,
                    });
                }
                featureList.push({
                    categoryName: category,
                    features: categoryFeatureList,
                });
            }
            if (oldList != null) {
                for (var idx = 0; idx < oldList.length; idx++) {
                    category = oldList[idx];
                    for (var i = 0, end = category.features.length - 1, asc = 0 <= end; asc ? i <= end : i >= end; asc ? i++ : i--) {
                        category.features[i].status = featureList[idx].features[i].status;
                        category.features[i].icon = featureList[idx].features[i].icon;
                        category.features[i].tooltip = featureList[idx].features[i].tooltip;
                    }
                }
                return oldList;
            }
            return featureList;
        };
        this.getFeatureComparisonList = function (currentPlan, selectedPlan, oldList) {
            var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
            var _e, _f, _g;
            var category, feature;
            var featureList = _this.getFeatureList(currentPlan, oldList);
            try {
                for (var _h = __values(Array.from(featureList)), _j = _h.next(); !_j.done; _j = _h.next()) {
                    category = _j.value;
                    try {
                        for (var _k = (e_2 = void 0, __values(Array.from(category.features))), _l = _k.next(); !_l.done; _l = _k.next()) {
                            feature = _l.value;
                            if (_this.featureCategories[category.categoryName][feature.name].tooltip && feature.status === "available") {
                                if (_this.featureCategories[category.categoryName][feature.name].tooltip.normal != null) {
                                    feature.tooltip = _this.featureCategories[category.categoryName][feature.name].tooltip.normal;
                                }
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_l && !_l.done && (_b = _k.return)) _b.call(_k);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_a = _h.return)) _a.call(_h);
                }
                finally { if (e_1) throw e_1.error; }
            }
            if (selectedPlan == null || currentPlan === selectedPlan) {
                return featureList;
            }
            try {
                for (var _m = __values(Array.from(featureList)), _o = _m.next(); !_o.done; _o = _m.next()) {
                    category = _o.value;
                    try {
                        for (var _p = (e_4 = void 0, __values(Array.from(category.features))), _q = _p.next(); !_q.done; _q = _p.next()) {
                            feature = _q.value;
                            if (lodash_1.default.includes(selectedPlan.features[category.categoryName], feature.name)) {
                                if (feature.status === "unavailable") {
                                    feature.status = "unlocking";
                                }
                            }
                            else if (feature.status === "available") {
                                feature.status = "locking";
                            }
                            if (selectedPlan.alternativeIcons[feature.name] != null) {
                                if (feature.icon !== selectedPlan.alternativeIcons[feature.name]) {
                                    feature.icon = selectedPlan.alternativeIcons[feature.name];
                                    if (selectedPlan.tier > currentPlan.tier) {
                                        feature.status = "unlocking";
                                    }
                                    else {
                                        feature.status = "trimming";
                                    }
                                }
                            }
                            if (feature.status === "locking" || feature.status === "trimming") {
                                if (((_e = _this.featureCategories[category.categoryName][feature.name].tooltip) === null || _e === void 0 ? void 0 : _e.downgrade) != null) {
                                    feature.tooltip = _this.featureCategories[category.categoryName][feature.name].tooltip.downgrade;
                                }
                            }
                            if (feature.status === "unlocking") {
                                if (((_f = _this.featureCategories[category.categoryName][feature.name].tooltip) === null || _f === void 0 ? void 0 : _f.upgrade) != null) {
                                    feature.tooltip = _this.featureCategories[category.categoryName][feature.name].tooltip.upgrade;
                                }
                                else if (((_g = _this.featureCategories[category.categoryName][feature.name].tooltip) === null || _g === void 0 ? void 0 : _g.normal) != null) {
                                    feature.tooltip = _this.featureCategories[category.categoryName][feature.name].tooltip.normal;
                                }
                            }
                        }
                    }
                    catch (e_4_1) { e_4 = { error: e_4_1 }; }
                    finally {
                        try {
                            if (_q && !_q.done && (_d = _p.return)) _d.call(_p);
                        }
                        finally { if (e_4) throw e_4.error; }
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_o && !_o.done && (_c = _m.return)) _c.call(_m);
                }
                finally { if (e_3) throw e_3.error; }
            }
            if (oldList != null) {
                for (var idx = 0; idx < oldList.length; idx++) {
                    category = oldList[idx];
                    for (var i = 0, end = category.features.length, asc = 0 <= end; asc ? i < end : i > end; asc ? i++ : i--) {
                        category.features[i].status = featureList[idx].features[i].status;
                        category.features[i].icon = featureList[idx].features[i].icon;
                        category.features[i].tooltip = featureList[idx].features[i].tooltip;
                    }
                }
                return oldList;
            }
            return featureList;
        };
        this.getPlanChangeVerb = function (selectedPlan) {
            if (!_this.usingEnterpriseSelfServeFF) {
                if ((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.displayName) === "Enterprise") {
                    return "get in touch";
                }
            }
            return "continue";
        };
        this.addTelemetryFields = function (updatedPlanInfo, internalPlans, planName, isMonthly) {
            var _a;
            var isUpgrading, verb;
            var internalName = _this.planService.getInternalPlan(internalPlans, planName, isMonthly).internalName;
            var interval = isMonthly ? "month" : "year";
            if (_this.isClosedOrExpired() ||
                _this.ui.currentPlan == null ||
                _this.ui.selectedPlan == null ||
                _this.ui.currentPlan.tier <= _this.ui.selectedPlan.tier) {
                verb = "upgrade";
                isUpgrading = true;
            }
            else {
                verb = "downgrade";
                isUpgrading = false;
            }
            var telemetryProperties = (_a = {},
                _a["".concat(verb, "_form_viewed_plan")] = internalName,
                _a["".concat(verb, "_form_viewed_plan_interval")] = interval,
                _a);
            return Object.assign(updatedPlanInfo, {
                isUpgrading: isUpgrading,
                telemetryProperties: telemetryProperties,
            });
        };
        this.planNameIncludesTrial = function () {
            var currentInternalName = _this.account.plan.internalName;
            return currentInternalName.includes("trial");
        };
        this.getCurrentPlan = function () {
            var currentPlanName;
            var currentInternalName = _this.account.plan.internalName;
            if (_this.planNameIncludesTrial()) {
                if (currentInternalName.startsWith("pro")) {
                    currentPlanName = "pro";
                }
                if (currentInternalName.startsWith("business")) {
                    currentPlanName = "business";
                }
                if (currentInternalName.startsWith("enterprise")) {
                    currentPlanName = "enterprise";
                }
            }
            else {
                currentPlanName = _this.account.plan.displayName.toLowerCase();
            }
            if (_this.plans[currentPlanName] == null) {
                currentPlanName = "starter";
            }
            return _this.plans[currentPlanName];
        };
        this.getCurrentUsers = function () {
            return _this.seatsService.currentlyOccupied();
        };
        this.isOnLivePaidPlan = function () {
            var _a, _b, _c, _d;
            return ((_b = (_a = _this.account.plan) === null || _a === void 0 ? void 0 : _a.internalName) === null || _b === void 0 ? void 0 : _b.includes("v10")) && !((_d = (_c = _this.account.plan) === null || _c === void 0 ? void 0 : _c.internalName) === null || _d === void 0 ? void 0 : _d.includes("trial"));
        };
        this.getCurrentPlanFrequency = function () {
            var _a, _b;
            if (((_a = _this.account.plan) === null || _a === void 0 ? void 0 : _a.unit) === "month") {
                return "monthly";
            }
            if (((_b = _this.account.plan) === null || _b === void 0 ? void 0 : _b.unit) === "year") {
                return "yearly";
            }
            else {
                return "";
            }
        };
        this.isCurrentlyPaidMonthly = function () {
            var _a;
            return ((_a = _this.account.plan) === null || _a === void 0 ? void 0 : _a.unit) === "month";
        };
        this.isClosedOrExpired = function () {
            return ["closed", "expired"].includes(_this.account.status);
        };
        this.isExactPlan = function (plan, isMonthly) {
            var sameFrequency;
            var sameTier = _this.account.plan.displayName === plan.displayName;
            if (plan.displayName === "Starter") {
                sameFrequency = true;
            }
            else {
                sameFrequency =
                    (_this.account.plan.unit === "month" && isMonthly) || (_this.account.plan.unit === "year" && !isMonthly);
            }
            return sameTier && sameFrequency;
        };
        this.canMakeChange = function (selectedPlan, isMonthly) {
            if (selectedPlan == null) {
                return false;
            }
            if (_this.businessTrial) {
                if (selectedPlan.displayName === "Business") {
                    return true;
                }
            }
            else if (!_this.isSubscribed() && selectedPlan.displayName !== "Starter") {
                if (!(selectedPlan.displayName === "Pro" && _this.getCurrentUsers() > 3)) {
                    return true;
                }
            }
            else {
                var isCurrent = _this.isExactPlan(selectedPlan, isMonthly) && _this.isOnLivePaidPlan();
                if (!isCurrent && !(selectedPlan.displayName === "Pro" && _this.getCurrentUsers() > 3)) {
                    return true;
                }
                else if (_this.getTrialDays() !== null) {
                    return true;
                }
            }
            return false;
        };
        this.initialSelection = function () {
            var _a;
            if (_this.usingEnterpriseSelfServeFF) {
                return _this.plans.enterprise;
            }
            if (_this.di.has("planInfo")) {
                var planInfo = _this.di.get("planInfo");
                if (((_a = planInfo.yearly) === null || _a === void 0 ? void 0 : _a.displayName) != null) {
                    return _this.plans[planInfo.yearly.displayName.toLowerCase()];
                }
            }
            else {
                return _this.getCurrentPlan();
            }
        };
        this.isMonthlyInitial = function () {
            if (_this.di.has("planInfo")) {
                var planInfo = _this.di.get("planInfo");
                if (planInfo.isMonthly != null) {
                    return planInfo.isMonthly;
                }
            }
            return false;
        };
        this.getNetFeatureChange = function (featureList) {
            var e_5, _a, e_6, _b;
            var count = 0;
            try {
                for (var _c = __values(Array.from(featureList)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var category = _d.value;
                    try {
                        for (var _e = (e_6 = void 0, __values(Array.from(category.features))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var feature = _f.value;
                            if (feature.status === "unlocking") {
                                count++;
                            }
                            else if (feature.status === "locking" || feature.status === "trimming") {
                                count--;
                            }
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_5) throw e_5.error; }
            }
            return count;
        };
        this.makingCancellation = function (selectedPlan) {
            var _a;
            if (selectedPlan.displayName === "Starter" && ((_a = _this.account.stripe) === null || _a === void 0 ? void 0 : _a.subToken) != null) {
                _this.overlayStack.closeCurrent();
                _this.$timeout(_this.cancelSubscription.cancel);
                return true;
            }
            return false;
        };
        this.saveData = function (plan, isMonthly) {
            var planName = plan.displayName.toLowerCase();
            if (_this.businessTrial) {
                planName = "trial";
            }
            return _this.planService
                .fetchPlans()
                .then(function (internalPlans) {
                var planInfo;
                var updatedPlanInfo = {
                    isMonthly: planName === "enterprise" && !_this.usingEnterpriseSelfServeFF ? false : isMonthly,
                    monthly: _this.planService.getInternalPlan(internalPlans, planName, true),
                    yearly: _this.planService.getInternalPlan(internalPlans, planName, false),
                };
                _this.addTelemetryFields(updatedPlanInfo, internalPlans, planName, isMonthly);
                if (_this.di.has("planInfo")) {
                    planInfo = _this.di.get("planInfo");
                    Object.assign(planInfo, updatedPlanInfo);
                }
                else {
                    planInfo = updatedPlanInfo;
                    _this.di.value("planInfo", planInfo);
                }
                if (plan.displayName === "Enterprise" && planInfo.yearly == null) {
                    return _this.$q.reject(new Error("Could not locate enterprise plan"));
                }
                else if (plan.displayName === "Trial" || plan.displayName === "Starter") {
                    if (planInfo.monthly == null && planInfo.yearly == null) {
                        return _this.$q.reject(new Error("Could not locate free plan"));
                    }
                }
                else if (planInfo.monthly == null || planInfo.yearly == null) {
                    return _this.$q.reject(new Error("Could not locate plan"));
                }
            })
                .catch(function (error) {
                _this.$log.error(error.message);
                return _this.$q.reject(new Error("Could not make plan change"));
            });
        };
        this.makeFeatureTooltip = function (feature) {
            return _this.hint.large({
                targetSelector: ".feature-wrapper.".concat(feature.name.replace(/ /g, "-"), "-plan-explorer"),
                hint: feature.tooltip,
            });
        };
        this.makeFeatureTooltips = function (featureList) {
            var e_7, _a, e_8, _b;
            var tooltips = [];
            try {
                for (var _c = __values(Array.from(featureList)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var category = _d.value;
                    try {
                        for (var _e = (e_8 = void 0, __values(Array.from(category.features))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var feature = _f.value;
                            if (feature.tooltip != null) {
                                var tip = _this.makeFeatureTooltip(feature);
                                tooltips.push(tip);
                            }
                        }
                    }
                    catch (e_8_1) { e_8 = { error: e_8_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_8) throw e_8.error; }
                    }
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_7) throw e_7.error; }
            }
            return tooltips;
        };
        this.updateFeatureTooltips = function (featureList, oldTooltips) {
            var e_9, _a;
            try {
                for (var _b = __values(Array.from(oldTooltips)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var tooltip = _c.value;
                    tooltip.remove();
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_9) throw e_9.error; }
            }
            return _this.makeFeatureTooltips(featureList);
        };
        this.completeScreen = function () {
            _this.overlayStack.setCustomClass("plan-explorer-background");
            return _this.onComplete();
        };
        this.close = function () {
            return _this.overlayStack.closeCurrent();
        };
        this.getTrialDays = function () {
            return _this.trial.daysRemaining();
        };
        this.submitHandleFunction = function () {
            return _this.$q
                .resolve()
                .then(function () {
                if (_this.ui.validChange()) {
                    if (!_this.usingEnterpriseSelfServeFF && _this.ui.selectedPlan.displayName === "Enterprise") {
                        window.open("https://qwilr.com/book-a-demo/", "_blank");
                        return;
                    }
                    if (_this.makingCancellation(_this.ui.selectedPlan)) {
                        return;
                    }
                    if (_this.account.hasCustomPlanAgreement) {
                        return _this.$q.reject(new Error("Contact support to change your plan"));
                    }
                    return _this.saveData(_this.ui.selectedPlan, _this.ui.isMonthly)
                        .then(function () {
                        return _this.completeScreen();
                    })
                        .catch(function (error) {
                        return _this.$q.reject(error);
                    });
                }
            })
                .catch(function (error) {
                _this.$q.reject(error);
                return _this.speechBubble.alert({
                    targetSelector: ".plan-explorer .submit-container",
                    message: error.message,
                    position: "bottom",
                });
            });
        };
        this.createButton = function (text, state) {
            return new _this.AsyncButton(_this.submitHandleFunction, text, {
                theme: "primary",
                initialState: state,
            });
        };
        this.bookDemoButton = function () {
            var onClick = function () {
                _this.ui.trackGetInTouch();
                window.open("https://qwilr.com/book-a-demo/", "_blank");
            };
            return new _this.AsyncButton(onClick, "Get in touch", {
                theme: "secondary",
                initialState: "idle",
            });
        };
        this.refreshButton = function () {
            var _a;
            if ((_a = _this.ui) === null || _a === void 0 ? void 0 : _a.submitButton) {
                var buttonNewState = _this.ui.validChange() ? "idle" : "disabled";
                _this.ui.submitButton.text = _this.ui.planChangeVerb;
                return (_this.ui.submitButton.state = buttonNewState);
            }
        };
        this.account = account;
        var planItems = invoke(PlanItems_1.default);
        this.plans = planItems.displayPlans;
        var featureCategories = planItems.featureCategories;
        this.featureCategories = featureCategories;
        this.usingEnterpriseSelfServeFF = usingFeature(FeatureFlag_1.default.EnterpriseSelfServe);
        var init = function () {
            _this.ui = createUi(require("./PlanExplorer.html"), getInitialUIData());
            overlayStack.setCustomClass("plan-explorer-background");
            overlayStack.hideCloseButton();
            if (!di.has("planInfo")) {
                return telemetry.track("Upgrade Pricing Viewed");
            }
        };
        var getInitialUIData = function () {
            return {
                usingEnterpriseSelfServeFF: _this.usingEnterpriseSelfServeFF,
                planList: _this.getPlanList(_this.isMonthlyInitial()),
                selectedPlan: _this.initialSelection(),
                currentPlan: _this.getCurrentPlan(),
                currentPlanFrequency: _this.getCurrentPlanFrequency(),
                currentUsers: _this.getCurrentUsers(),
                isCurrentlyPaidMonthly: _this.isCurrentlyPaidMonthly(),
                isOnLivePaidPlan: _this.isOnLivePaidPlan(),
                isClosedOrExpired: _this.isClosedOrExpired(),
                isMonthly: _this.isMonthlyInitial(),
                planChangeVerb: _this.getPlanChangeVerb(_this.initialSelection()),
                startTrialOnly: false,
                trialDays: _this.getTrialDays(),
                featureList: _this.getFeatureComparisonList(_this.getCurrentPlan(), _this.initialSelection()),
                netFeatureChange: _this.getNetFeatureChange(_this.getFeatureComparisonList(_this.getCurrentPlan(), _this.initialSelection())),
                featureToolTips: _this.makeFeatureTooltips(_this.getFeatureComparisonList(_this.getCurrentPlan(), _this.initialSelection())),
                getTotalToPay: function () {
                    var seatsToPay = Math.max(_this.ui.selectedPlan.minSeat, seatsService.currentlyOccupied());
                    if (_this.ui.isMonthly) {
                        return _this.ui.selectedPlan.monthlyPrice * seatsToPay;
                    }
                    return _this.ui.selectedPlan.annualPrice * 12 * seatsToPay;
                },
                getSingleUserPrice: function () {
                    if (_this.ui.isMonthly) {
                        return _this.ui.selectedPlan.monthlyPrice;
                    }
                    else {
                        return _this.ui.selectedPlan.annualPrice;
                    }
                },
                getFutureSeats: function () {
                    return Math.max(_this.ui.selectedPlan.minSeat, seatsService.currentlyOccupied());
                },
                goToManageSeats: function () {
                    _this.close();
                    return $state.go("settings", { section: "users" });
                },
                selectPlan: function (plan) {
                    if (plan.displayName.toLowerCase() === "enterprise" && !(0, eligibleForEntMonthly_1.eligibleForEntMonthly)(account)) {
                        _this.ui.isMonthly = false;
                    }
                    _this.ui.selectedPlan = _this.plans[plan.displayName.toLowerCase()];
                    _this.ui.featureList = _this.getFeatureComparisonList(_this.ui.currentPlan, _this.ui.selectedPlan, _this.ui.featureList);
                    _this.ui.planChangeVerb = _this.getPlanChangeVerb(_this.ui.selectedPlan);
                    _this.ui.netFeatureChange = _this.getNetFeatureChange(_this.ui.featureList);
                    _this.ui.featureToolTips = _this.updateFeatureTooltips(_this.ui.featureList, _this.ui.featureToolTips);
                    _this.ui.showFeatureCount = !_this.isClosedOrExpired();
                    return _this.refreshButton();
                },
                getClass: function (feature) {
                    if (feature.status === "unlocking") {
                        return _this.ui.selectedPlan.displayName.toLowerCase();
                    }
                    else {
                        return feature.status;
                    }
                },
                getFeatureNameClass: function (feature) {
                    return "".concat(feature.name.replace(/ /g, "-"), "-plan-explorer");
                },
                getPlanClass: function (plan) {
                    if (plan.displayName != null) {
                        return plan.displayName.toLowerCase();
                    }
                    else {
                        return plan.toLowerCase();
                    }
                },
                isSelectedPlan: function (plan) {
                    if (_this.ui.selectedPlan) {
                        return plan.displayName === _this.ui.selectedPlan.displayName;
                    }
                    else {
                        return false;
                    }
                },
                isCurrentTier: function (plan) {
                    return plan.displayName === _this.ui.currentPlan.displayName;
                },
                $init: function ($scope) {
                    $scope.$watch(function () { return _this.ui.isMonthly; }, function () {
                        _this.ui.planList = _this.getPlanList(_this.ui.isMonthly, _this.ui.planList);
                        _this.refreshButton();
                    });
                    _this.ui.frequencyOptionMenu = invoke(PlanExplorerFrequencyDropdown_1.mountPlanExplorerFrequencyDropdown, undefined, {
                        planExplorerUi: _this.ui,
                        $scope: $scope,
                        $timeout: $timeout,
                    });
                },
                onTrial: function () {
                    return _this.ui.trialDays != null || _this.planNameIncludesTrial();
                },
                validChange: function () {
                    return _this.canMakeChange(_this.ui.selectedPlan, _this.ui.isMonthly);
                },
                close: function () {
                    return _this.close();
                },
                bookDemoButton: _this.bookDemoButton(),
                submitButton: _this.createButton(_this.getPlanChangeVerb(_this.initialSelection()), _this.canMakeChange(_this.initialSelection(), _this.isMonthlyInitial()) ? "idle" : "disabled"),
                trackGetInTouch: function () {
                    return telemetry.track("Plan Explorer Get In Touch Clicked", {}, { blockIdentify: true, blockIntercom: true });
                },
            };
        };
        init();
    }
    return PlanExplorer;
}());
exports.default = PlanExplorer;
